import ACTIONS from "../constants/actions";

const {
  GET_ALL_NOTIFICATION_REQUEST,
  GET_ALL_NOTIFICATION_SUCCESS,
  GET_ALL_NOTIFICATION_FAIL,
  GET_NOTIFICATION_NUMBER_SUCCESS,
  GET_MORE_NOTIFICATION_REQUEST,
  GET_MORE_NOTIFICATION_SUCCESS,
  GET_MORE_NOTIFICATION_FAIL,
  GET_POLLING_NOTIFICATION_SUCCESS,
  MARK_AS_READ,
} = ACTIONS;

const initialState = {
  allNotifications: [],
  notificationNumber: 0,
  isLoadingNotification: false,
  isLoadingMore: false,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATION_NUMBER_SUCCESS:
      return {
        ...state,
        notificationNumber: action.payload,
      };

    case GET_ALL_NOTIFICATION_REQUEST:
      return {
        ...state,
        isLoadingNotification: true,
      };
    case GET_ALL_NOTIFICATION_SUCCESS:
      return {
        ...state,
        allNotifications: action.payload,
        isLoadingNotification: false,
      };
    case GET_ALL_NOTIFICATION_FAIL:
      return {
        ...state,
        isLoadingNotification: false,
      };

    case GET_MORE_NOTIFICATION_REQUEST:
      return {
        ...state,
        isLoadingMore: true,
      };
    case GET_MORE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        allNotifications: [...state.allNotifications, ...action.payload],
        isLoadingMore: false,
      };
    case GET_MORE_NOTIFICATION_FAIL:
      return {
        ...state,
        isLoadingMore: false,
      };

    case MARK_AS_READ:
      let newNotiList = [];
      if (action.payload === "all") {
        newNotiList = state.allNotifications.map((noti) => {
          if (noti.variables) {
            return { ...noti };
          }
          return { ...noti, isRead: true };
        });
      } else {
        newNotiList = state.allNotifications.map((noti) => {
          if (noti.id === action.payload) {
            return { ...noti, isRead: true };
          }
          return noti;
        });
      }
      return {
        ...state,
        allNotifications: newNotiList,
      };

    case GET_POLLING_NOTIFICATION_SUCCESS:
      const newNotiIds = action.payload.map((noti) => noti.id);
      if (state.allNotifications[0]) {
        const currentNotiId = state.allNotifications[0].id;
        const newNotiNum = newNotiIds.indexOf(currentNotiId);
        if (newNotiNum) {
          const newNoti = action.payload.splice(0, newNotiNum);
          return {
            ...state,
            allNotifications: [...newNoti, ...state.allNotifications],
          };
        }
      }

      return {
        ...state,
      };

    default:
      return state;
  }
};
export default notificationReducer;
